// Internal to AudienceContext. Components use the bound actions
// from useAudienceActions rather than dispatching these.

export const LOAD_AUDIENCE = "LOAD_AUDIENCE";
export const CREATE_AUDIENCE = "CREATE_AUDIENCE";
export const SAVED_AUDIENCE = "SAVED_AUDIENCE";
export const BUILD_AUDIENCE = "BUILD_AUDIENCE";
export const RESET = "RESET";

export const ADD_SEGMENTS = "ADD_SEGMENTS";
export const CHANGE_SEGMENT = "CHANGE_SEGMENT";
export const CHANGE_NAME = "CHANGE_NAME";
export const SHARE_AUDIENCE = "SHARE_AUDIENCE";

export const ADD_VARIABLE_GROUP = "ADD_VARIABLE_GROUP";
export const REMOVE_VARIABLE_GROUP = "REMOVE_VARIABLE_GROUP";
export const RESET_VARIABLE_GROUP = "RESET_VARIABLE_GROUP";
export const CHANGE_OPERATOR = "CHANGE_OPERATOR";
export const CHANGE_GROUP_OPERATOR = "CHANGE_GROUP_OPERATOR";
export const CHANGE_GROUP_VARIABLES = "CHANGE_GROUP_VARIABLES";
export const ADD_VARIABLES = "ADD_VARIABLES";
export const REMOVE_VARIABLE = "REMOVE_VARIABLE";
export const CHANGE_BUILD_MODE = "CHANGE_BUILD_MODE";
export const SET_GEO_FENCE = "SET_GEO_FENCE";

export const ADD_UPLOAD_FILE = "ADD_UPLOAD_FILE";
export const CLEAR_UPLOAD_FILE = "CLEAR_UPLOAD_FILE";
export const CHECK_UPLOAD_FILE = "CHECK_UPLOAD_FILE";
export const CHANGE_UPLOAD_MODE = "CHANGE_UPLOAD_MODE";
export const CHANGE_TRAVELTIME = "CHANGE_TRAVELTIME";

export const SET_SITES = "SET_SITES";
export const SET_SITE_CATCHMENT = "SET_SITE_CATCHMENT";
export const SET_SITE_CATEGORIES = "SET_SITE_CATEGORIES";
export const SET_SITE_DAY_TYPE = "SET_SITE_DAY_TYPE";
